import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import { TextField } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function NewsLetterSubscribersEditModal({subscriberDetails}) {

  console.log("sadksadkbsansa", subscriberDetails);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box sx={{
      minWidth: "100%"
    }}>
      <Box onClick={handleOpen} sx={{
        minWidth: "100%",
        padding: "0.3rem 1rem"
      }}>Edit</Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <FormControl fullWidth sx={{
              rowGap: "0.8rem"
            }}>
            <TextField id="outlined-basic" label="Email" variant="outlined" defaultValue={subscriberDetails.email} />
            <TextField id="outlined-basic" label="Name" variant="outlined" defaultValue={subscriberDetails.name} />
            <TextField id="outlined-basic" label="Mobile" type='number' variant="outlined" defaultValue={subscriberDetails.mobile} />
            <TextField id="outlined-basic" label="State" variant="outlined" defaultValue={subscriberDetails.state} />
            <TextField id="outlined-basic" label="City" variant="outlined" defaultValue={subscriberDetails.city} />
            </FormControl>

            <Box sx={{
              display: "flex",
              paddingTop: "0.5rem",
              justifyContent: "center"
            }}>
              <Button variant='contained'>Update</Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
}